

import axios from "axios";
import {
    sessionService,
    //scrapeService,
    ScrapeDataManager,
    SignalRScrapeService,
    UtilityLibrary,
    LoggerUtility,
    EnumUtility,
    SessionManager,
    ClientType
} from '../components/ComponentsLibrary';
import { ApiEndpoints, default as ApiKeyManager } from "./ApiConfig";

//const masterServerDBSchema = SessionManager.GetDataFromSession("SiteSettingsDetailsKey")?.masterDBSchema;
// ADD this helper function at the top of ApiManager.js after the imports:
const getMasterServerDBSchema = () => {
    try {
        const siteSettingsString = SessionManager.GetDataFromSession("SiteSettingsDetailsKey");
        
        if (!siteSettingsString) {
            return null;
        }
        
        const siteSettings = typeof siteSettingsString === 'string' 
            ? JSON.parse(siteSettingsString) 
            : siteSettingsString;
        
        return siteSettings?.masterDBSchema || null;
    } catch (error) {
        console.error('🔍 Error getting masterServerDBSchema:', error);
        return null;
    }
};
// utility.js
const ApiService = (() => {

    // Get the session login user value
    const getSessionLoginUserValue = () => sessionService.LoginUserInfo || null;

    const createStateIDHeader = () => {
        try {
            const stateID = getSessionLoginUserValue() ? getSessionLoginUserValue().stateID : 10;
            return { "stateID": `${stateID}`, }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "createStateIDHeader", {});
        }
    };

    const createSiteIDHeader = () => {
        try {
            const siteID = getSessionLoginUserValue() ? getSessionLoginUserValue().siteID : 10;
            return { "siteID": `${siteID}`, }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "createSiteIDHeader", {});
        }
    };

    const createUserInfoIDHeader = () => {
        try {
            const userInfoID = getSessionLoginUserValue() ? getSessionLoginUserValue().userInfoID : 10;
            return { "userInfoID": `${userInfoID}`, }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "createUserInfoIDHeader", {});
        }
    };

    const createLegacyUserIDHeader = () => {
        try {
            const legacyUserID = getSessionLoginUserValue() ? getSessionLoginUserValue().legacyUserID : 10;
            return { "legacyUserID": `${legacyUserID}`, }
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "createLegacyUserIDHeader", {});
        }
    };

    const createApiKeyHeader = (apiRequestorKey = "") => {
        try {
            switch (apiRequestorKey) {
                case EnumUtility.ApiRequestorKey.ClientAPI.ID:
                    const clientApiKey = ApiKeyManager.GetClientApiKey();
                    return { "ClientApiKey": clientApiKey, };

                case EnumUtility.ApiRequestorKey.SsoAPI.ID:
                    const ssoApiKey = ApiKeyManager.GetSsoApiKey();
                    return { "SsoApiKey": ssoApiKey, };

                case EnumUtility.ApiRequestorKey.MasterAPI.ID:
                    const masterApiKey = ApiKeyManager.GetMasterApiKey();
                    return { "MasterApiKey": masterApiKey, };

                case EnumUtility.ApiRequestorKey.DocumentAPI.ID:
                    const docApiKey = ApiKeyManager.GetDocApiKey();
                    return { "DocumentApiKey": docApiKey, };

                default:
                    return { "ApiKey": "key1", };
            }


        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "createApiKeyHeader", {});
        }
    };

    const createContentTypeHeader = () => {
        try {
            return ({
                'Content-Type': 'application/json',
            });
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "createContentTypeHeader", {});
        }
    };

    const createCustomContentTypeHeader = (contentType) => {
        try {
            return (contentType);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "createContentTypeHeader", {});
        }
    };

    /**
    * Merge multiple header objects into one
    * @param {Array<Object>} headerObjects - List of header objects to merge
    * @returns {Object} - Merged headers
    */
    const mergeHeaders = (...headerObjects) => {
        try {
            return Object.assign({}, ...headerObjects);
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "mergeHeaders", {});
        }
    };

    const getApiHeaders = (options = {}, apiRequestorKey) => {
        try {
            // Merge all headers (default and additional)
            const headers = mergeHeaders(
                createStateIDHeader(),
                createSiteIDHeader(),
                createUserInfoIDHeader(),
                createLegacyUserIDHeader(),
                createApiKeyHeader(apiRequestorKey),
                createContentTypeHeader(),
                options.headers || {} // Allow additional headers to be added dynamically        
            );

            return headers;
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getApiHeaders", {});
        }
    };

    const getApiCustomHeaders = (options = {}, apiRequestorKey) => {
        try {
            // Merge all headers (default and additional)
            const headers = mergeHeaders(
                createStateIDHeader(),
                createSiteIDHeader(),
                createUserInfoIDHeader(),
                createLegacyUserIDHeader(),
                createApiKeyHeader(apiRequestorKey),
                createCustomContentTypeHeader(options.contentType),
                options.headers || {} // Allow additional headers to be added dynamically        
            );

            return headers;
        }
        catch (error) {
            throw LoggerUtility.ProcessErrorData(error, "getApiHeaders", {});
        }
    };


    return {
        getSessionLoginUserValue,
        createStateIDHeader,
        createSiteIDHeader,
        createUserInfoIDHeader,
        createLegacyUserIDHeader,
        createApiKeyHeader,
        createContentTypeHeader,
        createCustomContentTypeHeader,
        mergeHeaders,
        getApiHeaders,
        getApiCustomHeaders,
    };
})();


const errorFormName = "API Manager";

const caseInfoMapping = {

        caseNumber: ["CaseNumber", "caseNumber"],  
        caseFound: "caseFound",
        caseStatus: "caseStatus", 
        caseStatusID: ["caseStatusID", "CaseStatus", "mf_CaseStatus_ID"],  // CaseStatus is from Mainframe
        caseType: ["CaseType", "caseType"],             
        caseTypeID: ["CaseTypeID", "caseTypeID"],             
        caseWorker: ["CaseworkerName", "caseWorker", "caseworkerName"],  
        countyID: ["CountyID", "countyID"],
        confidentialCase: ["ConfidentialCase", "confidentialCase"],                          
        countyName: "",
        cpFirstName: ["CPFirstName", "cpFirstName"],
        cpFullName: ["CPName", "cpFullName"],
        cpLastName: ["CPLastName", "cpLastName"],
        cpssn: ["CPSSN", "cpssn"],
        createdTS: "",
        districtID: ["DistrictID", "districtID"],
        familyViolence: ["FamilyViolence", "familyViolence"],
        fVIAndConfidentialCase: "FVIAndConfidentialCase",
        fKM_UserLoginID: "",
        lastViewed: "",
        ncpFirstName: ["NCPFirstName", "ncpFirstName"],
        ncpFullName: ["NCPName", "ncpFullName"],
        ncpLastName: ["NCPLastName", "ncpLastName"],
        cpncp_NDI_IND  :"cpncP_NDI_IND",// RC we could just use lowercase to check
        ncpssn: ["NCPSSN", "ncpssn"],
        restrictedStatusMessage: "RestrictedStatusMessage",
        specialCircumstanceContent: ["specialCircumstanceContent", "SpecialCircumstanceContent"],
        specialCircumstanceContentActive: ["specialCircumstanceContentActive", "SpecialCircumstanceContentActive"],
        statusType: ["CaseStatus", "statusType"],   // This looks like a problem.
        statusTypeID: ["StatusTypeID", "statusTypeID"], 
        yTracCaseID: "yTracCaseID",

    };

const extractKansasCaseData = (caseApiData) => {
    const stateCaseData = caseApiData?.caseListStateInfo
        ?? caseApiData?.CaseListStateInfo
        ?? caseApiData?.[1];

    return Array.isArray(stateCaseData)
        ? stateCaseData[0] ?? null
        : stateCaseData ?? null;
};

// The Client API serializes MainframeScrapeData using lower-camel-case names.
// Normalize the Kansas result to the established mapping inputs, while keeping
// every Kansas response field available to downstream consumers.
const normalizeKansasCaseData = (caseData) => {
    if (!caseData || typeof caseData !== "object") {
        return {};
    }

    return {
        ...caseData,
        CaseNumber: caseData.CaseNumber ?? caseData.caseNumber,
        CaseStatus: caseData.CaseStatus ?? caseData.caseStatus,
        CaseType: caseData.CaseType ?? caseData.caseType,
        CaseworkerName: caseData.CaseworkerName ?? caseData.caseworkerName,
        CountyID: caseData.CountyID ?? caseData.countyID,
        ConfidentialCase: caseData.ConfidentialCase ?? caseData.confidentialCase,
        CPFirstName: caseData.CPFirstName ?? caseData.cpFirstName,
        CPName: caseData.CPName ?? caseData.cpName ?? caseData.cpFullName,
        CPLastName: caseData.CPLastName ?? caseData.cpLastName,
        CPSSN: caseData.CPSSN ?? caseData.cpssn,
        DistrictID: caseData.DistrictID ?? caseData.districtID,
        FamilyViolence: caseData.FamilyViolence ?? caseData.familyViolence,
        FVIAndConfidentialCase: caseData.FVIAndConfidentialCase ?? caseData.fviAndConfidentialCase,
        NCPFirstName: caseData.NCPFirstName ?? caseData.ncpFirstName,
        NCPName: caseData.NCPName ?? caseData.ncpName ?? caseData.ncpFullName,
        NCPLastName: caseData.NCPLastName ?? caseData.ncpLastName,
        NCPSSN: caseData.NCPSSN ?? caseData.ncpssn,
        RestrictedStatusMessage: caseData.RestrictedStatusMessage ?? caseData.restrictedStatusMessage,
    };
};

const GetApiHeaders = async (options = {}, apiRequestorKey, key = -99) => {
    try {
        return ApiService.getApiHeaders(options, apiRequestorKey);
    } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetApiHeaders", {});
    }
}

const GetDataFromAPI = async (apiEndPoint, options = {}, key = -99) => {
    try {
        const apiHeaders = ApiService.getApiHeaders(options, apiEndPoint.ApiKey);
        const config = { headers: { ...apiHeaders } };
        const response =
            await axios.get(
                apiEndPoint.ApiUrl,
                config
            );

        // Check if the response is valid and has data
        if (response.status === 200 && response.data) {
            const responseData = response.data;

            // Convert response data to an array
            const dataArray = Array.isArray(responseData)
                ? responseData
                : Object.values(responseData);

            return dataArray;
        } else {
            console.error("Invalid response structure or no data found");
            return [];
        }
    } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetDataFromAPI", {});
    }
};

const GetDataWithParamsFromAPI = async (apiEndPoint, paramsforApi, options = {}, key = -99) => {
    try {
        /* console.log(paramsforApi); */
        const apiHeaders = ApiService.getApiHeaders(options, apiEndPoint.ApiKey);
        const config = {
            params: paramsforApi,
            headers: { ...apiHeaders }
        };
        const response =
            await axios.get(
                apiEndPoint.ApiUrl,
                config
            );

        // Check if the response is valid and has data
        if (response.status === 200 && response.data) {
            const responseData = response.data;

            // Convert response data to an array
            const dataArray = Array.isArray(responseData)
                ? responseData
                :(typeof responseData === "object")
                ? Object.values(responseData)
                : responseData;

            return dataArray;
        } else {
            console.error("Invalid response structure or no data found");
            return [];
        }
    } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetDataWithParamsFromAPI", {});
    }
};

const GetDataWithoutParamsFromAPI = async (apiEndPoint, options = {}, key = -99) => {
    try {
        /* console.log(paramsforApi); */
        const apiHeaders = ApiService.getApiHeaders(options, apiEndPoint.ApiKey);
        const config = {
            headers: { ...apiHeaders }
        };
        const response =
            await axios.get(
                apiEndPoint.ApiUrl,
                config
            );

        // Check if the response is valid and has data
        if (response.status === 200 && response.data) {
            const responseData = response.data;

            // Convert response data to an array
            const dataArray = Array.isArray(responseData)
                ? responseData
                : Object.values(responseData);

            return dataArray;
        } else {
            console.error("Invalid response structure or no data found");
            return [];
        }
    } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetDataWithoutParamsFromAPI", {});
    }
};


const PostDataToAPI = async (apiEndPoint, postData, configOptions = {}, options = {}, key = -99) => {
    try {
        const apiHeaders = ApiService.getApiHeaders(options, apiEndPoint.ApiKey);
        const config = { headers: { ...apiHeaders }, configOptions };
        const response = await axios.post(
            apiEndPoint.ApiUrl,
            postData,
            config
        );

        // Check if the response is valid and has data
        if (response.status === 200 && response.data) {
            const responseData = response.data;

            // Convert response data to an array
            const dataArray = Array.isArray(responseData)
                ? responseData
                : Object.values(responseData);

            return dataArray;
        } else {
            console.error("Invalid response structure or no data found");
            return [];
        }
    } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostDataToAPI", {});
    }
};

const PostDataFromParamsToAPI = async (apiEndPoint, paramsforApi, options = {}, key = -99) => {
    try {
        const apiHeaders = ApiService.getApiHeaders(options, apiEndPoint.ApiKey);
        const config = {
            params: paramsforApi,
            headers: { ...apiHeaders }
        };

        const response = await axios.post(
            apiEndPoint.ApiUrl,
            null,
            config
        );

        // Check if the response is valid and has data
        if (response.status === 200 && response.data) {
            const responseData = response.data;

            // Convert response data to an array
            const dataArray = Array.isArray(responseData)
                ? responseData
                : Object.values(responseData);

            return dataArray;
        } else {
            console.error("Invalid response structure or no data found");
            return [];
        }
    } catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostDataFromParamsToAPI", {});
    }
};


const FetchControlsPermissions = async (params) => {
    try {
        const controlSecurityAPIurl = await ApiEndpoints.SecurityControlsApiUrl();
        const controlSecurityListApiData = await GetDataWithParamsFromAPI(controlSecurityAPIurl, params, {}, 123456);
        return controlSecurityListApiData;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "FetchControlsPermissions", {});
    }
};

const FetchAppBarPermissions = async (params) => {
    try {
        const controlSecurityAPIurl = await ApiEndpoints.AppBarPermissionsApiUrl();
        const controlSecurityListApiData = await GetDataWithParamsFromAPI(controlSecurityAPIurl, params, {}, 123456);
        return controlSecurityListApiData;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "FetchAppBarPermissions", {});
    }
};


const PostNewDocToApi = async (newDocData) => {
    try {
        const newDocAPIurl = await ApiEndpoints.PostNewDocSaveApiUrl();
        const newDocApiData = await PostDataToAPI(newDocAPIurl, newDocData, {}, {}, 10);
        if (newDocApiData.length > 0) {
            return newDocApiData[0];
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostNewDocToApi", {});
    }
}

const PostDocTransferLogG4ToApi = async (docTransferLogData) => {
    try {
        const docTransferLogAPIurl = await ApiEndpoints.PostDocTransferLogG4ApiUrl();
        
        const docTransferLogApiData = await PostDataToAPI(docTransferLogAPIurl, docTransferLogData, {}, {}, 11);
        
        if (docTransferLogApiData && docTransferLogApiData.length > 0) {
            return {
                success: true,
                data: docTransferLogApiData[0]
            };
        }
        else {
            return {
                success: true,
                data: null
            };
        }
    }
    catch (error) {
        const processedError = LoggerUtility.ProcessErrorData(error, "PostDocTransferLogG4ToApi", {});
        return {
            success: false,
            error: processedError.message || 'Failed to log document transfer'
        };
    }
}

const PostManageKeywordToApi = async (newManageKeywordData) => {
    try {
        const newManageKeyAPIurl = await ApiEndpoints.PostManageKeywordSaveApiUrl();
        const newManageKeyApiData = await PostDataToAPI(newManageKeyAPIurl, newManageKeywordData, {}, {}, 20);
        if (newManageKeyApiData.length > 0) {
            return newManageKeyApiData[0];
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostManageKeywordToApi", {});
    }
}


const PostBatchInsertUpdateToApi = async (batchData) => {
    try {
        const batchAPIurl = await ApiEndpoints.PostBatchInsertUpdateApiUrl();
        const batchApiData = await PostDataToAPI(batchAPIurl, batchData, {}, {}, 200);
        if (batchApiData.length > 0) {
            return batchApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostBatchInsertUpdateToApi", {});
    }
}


const PostBatchDocumentToApi = async (batchDocumentData) => {
    try {
        const batchDocAPIurl = await ApiEndpoints.PostBatchDocumentApiUrl();
        batchDocumentData.masterServerDBSchema = getMasterServerDBSchema();
        const batchDocApiData = await PostDataToAPI(batchDocAPIurl, batchDocumentData, {}, {}, 100);
        if (batchDocApiData.length > 0) {
            return batchDocApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostNewDocToApi", {});
    }
}


const GetUncFilePathFromApi = async (fileName) => {
    try {
        const docUncAPIurl = await ApiEndpoints.DocumentUncApiUrl();
        const apiHeaders = ApiService.getApiHeaders({}, docUncAPIurl.ApiKey);
        const config = { 
            headers: { ...apiHeaders },
            responseType: 'arraybuffer'
        };
        const response = await axios.post(
            docUncAPIurl.ApiUrl,
            { path: fileName },
            config
        );
        return response;
    }
    catch (error) {
        throw error //TODO loggerutility
        // throw LoggerUtility.ProcessErrorData(error, "GetUncFilePathFromApi", {});
    }
}

const GetMetadataFromApi = async (fileName, documentName) => {
    try {
        const metadataEndpoint = await ApiEndpoints.ClientDocumentMetadataApiUrl();
        const apiHeaders = ApiService.getApiHeaders({}, metadataEndpoint.ApiKey);

        const response = await axios.post(
            metadataEndpoint.ApiUrl,
            { path: fileName, documentName },
            { headers: { ...apiHeaders } }
        );

        return response.data;
    }
    catch (error) {
        throw error // TODO loggerutility
        // throw LoggerUtility.ProcessErrorData(error, "GetMetadataFromApi", {});
    }
}

const SaveFileToPhysicalPath = async (documentData) => {
    try {
        const docUploadAPIurl = await ApiEndpoints.DocumentUploadApiUrl();
        const options = {
            contentType: {
                'Content-Type': 'multipart/form-data',
            },
        }
        const apiHeaders = ApiService.getApiCustomHeaders(options, docUploadAPIurl.ApiKey);
        const config = {
            headers: { ...apiHeaders }
        };
        const response = await axios.post(
            docUploadAPIurl.ApiUrl,
            documentData,
            config
        );
        return response;
        /* 
        const docUploadAPIurl = await ApiEndpoints.DocumentUploadApiUrl();
        const docUploadApiData = await PostDataToAPI(docUploadAPIurl, documentData, {}, {}, 4010);
        if (docUploadApiData.length > 0) {
            return docUploadApiData;
        }
        else {
            return null;
        } */
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "SaveFileToPhysicalPath", {});
    }
}


const DeleteDocumentFromApi = async (fileName) => {
    try {
        const docUncAPIurl = await ApiEndpoints.DocumentDeleteApiUrl();
        const apiHeaders = ApiService.getApiHeaders({}, docUncAPIurl.ApiKey);
        const config = { 
            headers: { ...apiHeaders },
        };
        const response = await axios.post(
            docUncAPIurl.ApiUrl,
            { path: fileName },
            config
        );
        return response;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "DeleteDocumentFromApi", {});
    }
}


const PostLogFromWebToApi = async (errorLogData) => {
    try {
        /* const errorLog = {
            Name: errorLogData.Name,
            Message: errorLogData.Message,
            ErrorTrace: JSON.stringify(errorLogData.ErrorTrace),
            Details: JSON.stringify(errorLogData.Details), // Convert to string for API
            StackTrace: errorLogData.StackTrace, // Include full stack trace
            Timestamp: new Date().toISOString(),
          }; */

        const logAPIurl = await ApiEndpoints.PostLogManageApiUrl();
        const logApiData = await PostDataToAPI(logAPIurl, errorLogData, {}, {}, 30);
        if (logApiData.length > 0) {
            return logApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostLogFromWebToApi", {});
    }
}

const GetOrganizationFromApiByUserID = async (params) => {
    try {
        const orgAPIurl = await ApiEndpoints.OrgsApiUrl();
        const orgApiData = await GetDataWithParamsFromAPI(orgAPIurl, params, {}, 2010);
        if (orgApiData.length > 0) {
            return orgApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetOrganizationFromApiByUserID", {});
    }
};

const GetChildOrganizationFromApiByUserID = async (params) => {
    try {
        const childOrgAPIurl = await ApiEndpoints.ChildOrgsApiUrl();
        const childOrgApiData = await GetDataWithParamsFromAPI(childOrgAPIurl, params, {}, 2020);
        if (childOrgApiData.length > 0) {
            return childOrgApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetChildOrganizationFromApiByUserID", {});
    }
};

const GetCaseFromLocalDB = async (caseApiData) => {
    try {
        let caseData = [];
        if (caseApiData[0].length > 0) {
            caseData = caseApiData[0];
        }

        return {
            caseInfo: caseData,
            statusCode: caseApiData[3],
            errorMessage: caseApiData[2]
        };
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetCaseFromLocalDB", {});
    }

};



const OnReturnCaseDataFromMainframe = async (paramsObj, configForRequest = {}) => {
    try {
        if (configForRequest.stateID === EnumUtility.StateIDKey.Kansas.ID) {
            const paramsForRequest = {
                apiMainframeUrl: paramsObj.apiMainframeUrl,
                blockID: paramsObj.blockID || EnumUtility.MainframePushBlockID.KansasCaseSearch.ID,
                requestJSON: {
                    CaseNumber: paramsObj.caseNumber,
                }
            };
            return await ScrapeDataManager.GetCaseDataFromScrape(paramsForRequest);
        }
        else if (configForRequest.stateID === EnumUtility.StateIDKey.Mississippi.ID) {
            const paramsForRequest = {
                apiMainframeUrl: paramsObj.apiMainframeUrl,
                blockID: paramsObj.blockID || EnumUtility.MainframePushBlockID.MississippiCaseSearch.ID,
                requestJSON: {
                    CaseNumber: paramsObj.caseNumber,
                }
            };
            return await ScrapeDataManager.GetCaseDataFromScrape(paramsForRequest);
        }
        return {};
    }
    catch (error) {
        const errorType = error?.Details?.type;
        if ([
            EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.Name,
            EnumUtility.CaseSearchResultCode.ScraperDisconnectedError.Name,
            EnumUtility.CaseSearchResultCode.Enter_A_Function_Error.Name
        ].includes(errorType)) {
    throw error;
}
        else {
            throw LoggerUtility.ProcessErrorData(error, "OnReturnCaseDataFromMainframe", {});
        }
    }
};

const CheckMainframeConnectivity = async (apiMainframeUrl) => {
  try {

        const stateID =  SessionManager.GetDataFromSession("LoginUserInfoKey")?.stateID;

        let blockID = 71; // Default for Mississippi
        if (stateID === EnumUtility.StateIDKey.Kansas.ID) {
            blockID = 45; // Kansas uses different BlockID
        }

        const params = {
            caseNumber: "Dummy",
            apiMainframeUrl: apiMainframeUrl,
            masterServerDBSchema: "Dummy",
            blockID: blockID 
        };
    
        const sessionLoginUser = ApiService.getSessionLoginUserValue();

        const configForRequest = {
            stateID: sessionLoginUser.stateID,
        };
        
        const mainframeData = await OnReturnCaseDataFromMainframe(params, configForRequest);

console.log("MAINFRAME DATA", mainframeData)
        if (mainframeData && mainframeData.ErrorCode == "" && mainframeData.CaseNumber == "Dummy") {
            return {
                caseInfo: null, 
                statusCode: EnumUtility.CaseSearchResultCode.ConnectionTestSuccess.ID,
                errorMessage: "",
                yTracCaseID: null
            };
        } else {

        // 🔍 STANDARDIZED: Always return consistent format
        return {
            caseInfo: null, 
            statusCode: EnumUtility.CaseSearchResultCode.OtherError.ID,
            errorMessage: "An error occurred while checking the Mainframe connection.",
            yTracCaseID: null
        };
    }
        
    }
        catch (error) {
      // 🔍 STANDARDIZED: Return consistent error format
         let statusCode = EnumUtility.CaseSearchResultCode.OtherError.ID;
        const errorType = error?.Details?.type;
        if (errorType === EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.Name)
            statusCode = EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.ID;
        else if (errorType === EnumUtility.CaseSearchResultCode.ScraperDisconnectedError.Name)
            statusCode = EnumUtility.CaseSearchResultCode.ScraperDisconnectedError.ID;
        else if (errorType === EnumUtility.CaseSearchResultCode.Enter_A_Function_Error.Name)
            statusCode = EnumUtility.CaseSearchResultCode.Enter_A_Function_Error.ID;
        return {
            caseInfo: null,
            statusCode,
            errorMessage: error.message || "An error occurred while checking the Mainframe connection.",
            yTracCaseID: null
        };
    }
}

// Left side searches: Call state systems (API for KS/MS, API for WY, DB for others)
// Update GetCaseDataFromApiByID to return consistent format
const GetCaseDataFromApiByID = async (paramsObj) => {
  try {
        const sessionLoginUser = ApiService.getSessionLoginUserValue();
        const caseAPIurl = await ApiEndpoints.CaseDetailsApiUrl();
        const isMainframeIntegration = UtilityLibrary.DetermineIfMainframeHost();
        const isAPIIntegration = UtilityLibrary.DetermineIfAPIHost();

        if (isMainframeIntegration) {

            const configForRequest = {
                stateID: sessionLoginUser.stateID,
            };
            const mainframeData = await OnReturnCaseDataFromMainframe(paramsObj, configForRequest);
            let caseInfoData = UtilityLibrary.mapApiResponseToObject(mainframeData.caseInfo, caseInfoMapping);
            
            // G2 IMPLEMENTATION: Add formatted SSN fields for DocTransferLog compatibility
            if (mainframeData.caseInfo) {
                caseInfoData.cpSSNFormatted = UtilityLibrary.formatSSN(mainframeData.caseInfo.CPSSN);
                caseInfoData.ncpSSNFormatted = UtilityLibrary.formatSSN(mainframeData.caseInfo.NCPSSN);
            }
            
            // Get YTracCaseID from DB
            const dbData = await ApiManager.GetCaseDataFromDbByID(paramsObj);
            const { yTracCaseID = null, specialCircumstanceContent, specialCircumstanceContentActive } = dbData?.caseInfo || {};
            caseInfoData = { ...caseInfoData, yTracCaseID, specialCircumstanceContent, specialCircumstanceContentActive };

            // 🔍 STANDARDIZED: Always return consistent format
            return {
                caseInfo: caseInfoData, //mainframeData.caseInfo ? (Array.isArray(mainframeData.caseInfo) ? mainframeData.caseInfo[0] : mainframeData.caseInfo) : null,
                statusCode: mainframeData.statusCode || EnumUtility.CaseSearchResultCode.Success.ID,
                errorMessage: mainframeData.errorMessage || null,
                yTracCaseID: yTracCaseID
            };
        }
        else if (isAPIIntegration) {
            let caseApiUrl;
            let caseApiParams = paramsObj;
            switch (sessionLoginUser.stateID) {
                case EnumUtility.StateIDKey.Wyoming.ID:
                    caseApiUrl = await ApiEndpoints.CaseDetailsWYAPIApiUrl();
                    break;
                case EnumUtility.StateIDKey.Virginia.ID:
                    caseApiUrl = await ApiEndpoints.CaseDetailsVAAPIApiUrl();
                    break;
                case EnumUtility.StateIDKey.Kansas.ID:
                    caseApiUrl = await ApiEndpoints.CaseDetailsKSAPIApiUrl();
                    caseApiParams = {
                        caseNumber: paramsObj.caseNumber
                    };
                    break;
                default:
                    throw new Error(`No case API endpoint is configured for state ID ${sessionLoginUser.stateID}.`);
            }

            const caseApiData = await GetDataWithParamsFromAPI(caseApiUrl, caseApiParams, {}, 10);

            console.log('Case API Data:', caseApiData);

            const isKansasAPI = sessionLoginUser.stateID === EnumUtility.StateIDKey.Kansas.ID;

            const extractedCaseData = isKansasAPI
                ? extractKansasCaseData(caseApiData)
                : (Array.isArray(caseApiData[1]) ? caseApiData[1][0] : caseApiData[1]);
            const rawCaseData = isKansasAPI
                ? normalizeKansasCaseData(extractedCaseData)
                : extractedCaseData;

            const mappedCaseInfoData = UtilityLibrary.mapApiResponseToObject(rawCaseData ?? {}, caseInfoMapping);
            const caseInfoData = isKansasAPI
                ? { ...rawCaseData, ...mappedCaseInfoData }
                : mappedCaseInfoData;
            
            // G2 IMPLEMENTATION: Add formatted SSN fields for DocTransferLog compatibility
            if (rawCaseData) {
                caseInfoData.cpSSNFormatted = UtilityLibrary.formatSSN(rawCaseData.CPSSN || rawCaseData.cpssn);
                caseInfoData.ncpSSNFormatted = UtilityLibrary.formatSSN(rawCaseData.NCPSSN || rawCaseData.ncpssn);
            }

            // 🔍 STANDARDIZED: Return consistent format
            return {
                caseInfo: caseInfoData, // Array.isArray(caseApiData[1]) ? caseApiData[1][0] : caseApiData[1],
                statusCode: caseApiData[3] || EnumUtility.CaseSearchResultCode.Success.ID,
                errorMessage: caseApiData[2] || null,
                yTracCaseID: rawCaseData?.yTracCaseID || null
            };
        }
        else { // Default to database for other states
            const caseApiData = await GetDataWithParamsFromAPI(caseAPIurl, paramsObj, {}, 10);
            const localDbResult = await GetCaseFromLocalDB(caseApiData);

            const caseInfoData = UtilityLibrary.mapApiResponseToObject(localDbResult.caseInfo[0], caseInfoMapping);

            // 🔍 STANDARDIZED: Ensure consistent format from local DB
            return {
                caseInfo: localDbResult.caseInfo && Array.isArray(localDbResult.caseInfo) && localDbResult.caseInfo.length > 0 
                    ? caseInfoData 
                    : localDbResult.caseInfo,
                statusCode: localDbResult.statusCode || EnumUtility.CaseSearchResultCode.NotFound.ID,
                errorMessage: localDbResult.errorMessage || null,
                yTracCaseID: localDbResult.caseInfo && Array.isArray(localDbResult.caseInfo) && localDbResult.caseInfo.length > 0 
                    ? localDbResult.caseInfo[0]?.yTracCaseID 
                    : localDbResult.caseInfo?.yTracCaseID || null
            };
        }
    }
    catch (error) {
      // 🔍 STANDARDIZED: Return consistent error format
        let statusCode = EnumUtility.CaseSearchResultCode.OtherError.ID;
        const isKansasAPI = ApiService.getSessionLoginUserValue()?.stateID === EnumUtility.StateIDKey.Kansas.ID;
        const apiProblemDetails = isKansasAPI ? error?.ApiProblemDetails : null;
        const errorType = error?.Details?.type;
        if (apiProblemDetails?.status === 404)
            statusCode = EnumUtility.CaseSearchResultCode.CaseNotFound.ID;
        else if (errorType === EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.Name)
            statusCode = EnumUtility.CaseSearchResultCode.MFSessionDisconnectError.ID;
        else if (errorType === EnumUtility.CaseSearchResultCode.ScraperDisconnectedError.Name)
            statusCode = EnumUtility.CaseSearchResultCode.ScraperDisconnectedError.ID;
        else if (errorType === EnumUtility.CaseSearchResultCode.Enter_A_Function_Error.Name)
            statusCode = EnumUtility.CaseSearchResultCode.Enter_A_Function_Error.ID;
        return {
            caseInfo: null,
            statusCode,
            errorMessage: apiProblemDetails?.detail || error.message || "An error occurred while fetching case data",
            apiError: apiProblemDetails,
            yTracCaseID: null
        };
    }
};

// Right pane searches: Always go to database only (never mainframe/state systems)
// Return consistent format
const GetCaseDataFromDbByID = async (paramsObj) => {
    try {
        const sessionLoginUser = ApiService.getSessionLoginUserValue();
        const caseAPIurl = await ApiEndpoints.CaseDetailsApiUrl();
        
        // Always route to database, never mainframe - for right pane searches
        const caseApiData = await GetDataWithParamsFromAPI(caseAPIurl, paramsObj, {}, 10);
        const localDbResult = await GetCaseFromLocalDB(caseApiData);
        const caseInfoData = UtilityLibrary.mapApiResponseToObject(localDbResult.caseInfo[0], caseInfoMapping);

            // 🔍 STANDARDIZED: Ensure consistent format
            return {
                caseInfo: localDbResult.caseInfo && Array.isArray(localDbResult.caseInfo) && localDbResult.caseInfo.length > 0 
                    ? caseInfoData
                    : localDbResult.caseInfo,
                statusCode: localDbResult.statusCode || EnumUtility.CaseSearchResultCode.NotFound.ID,
                errorMessage: localDbResult.errorMessage || null,
                yTracCaseID: localDbResult.caseInfo && Array.isArray(localDbResult.caseInfo) && localDbResult.caseInfo.length > 0 
                    ? localDbResult.caseInfo[0]?.yTracCaseID 
                    : localDbResult.caseInfo?.yTracCaseID || null
            };
        }
        catch (error) {
            // 🔍 STANDARDIZED: Return consistent error format
            return {
                caseInfo: null,
                statusCode: EnumUtility.CaseSearchResultCode.Error.ID,
                errorMessage: error.message || "An error occurred while fetching case data from DB",
                yTracCaseID: null
            };
    }
};

const PostCaseDataFromScrapeToApi = async (newScrapeData) => {
    try {
        const newScrapeAPIurl = await ApiEndpoints.CaseInsertUpdateApiUrl();
        newScrapeData.masterServerDBSchema = getMasterServerDBSchema(); //Added to params.
        const newScrapeApiData = await PostDataToAPI(newScrapeAPIurl, newScrapeData, {}, {}, 11);
        if (newScrapeApiData[1].length > 0) {
            return {
                caseInfo: newScrapeApiData[1],
                statusCode: newScrapeApiData[3],
                errorMessage: newScrapeApiData[2]
            };
            //return caseApiData[1];
        }
        else {
            return await GetCaseFromLocalDB(newScrapeApiData);
            /* if (caseApiData[0].length > 0) {
                return caseApiData[0];
            }
            else {
                return [];
            } */
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostCaseDataFromScrapeToApi", {});
    }
}

const GetDocSearchFromApiByID = async (params) => {
    try {
        const docSearchAPIurl = await ApiEndpoints.DocumentSearchApiUrl();
        const docSearchApiData = await GetDataWithParamsFromAPI(docSearchAPIurl, params, {}, 20);
        if (docSearchApiData.length > 0) {
            return docSearchApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetDocSearchFromApiByID", {});
    }
};



const GetCaseDocsFromApiByCaseID = async (params) => {
    try {
        const caseDocsAPIurl = await ApiEndpoints.CaseDocumentsApiUrl();
        const caseDocsApiData = await GetDataWithParamsFromAPI(caseDocsAPIurl, params, {}, 30);
        if (caseDocsApiData.length > 0) {
            return caseDocsApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetCaseDocsFromApiByCaseID", {});
    }
};

const GetCaseDocsFromApiByCaseWorkflowID = async (params) => {
    try {
        const caseDocsAPIurl = await ApiEndpoints.DocumentsByCaseWorkflowIDApiUrl();
        const caseDocsApiData = await GetDataWithParamsFromAPI(caseDocsAPIurl, params, {}, 30);
        if (caseDocsApiData.length > 0) {
            return caseDocsApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetCaseDocsFromApiByCaseWorkflowID", {});
    }
};


const GetBatchDocsFromApiByBatchID = async (params) => {
    try {
        const batchDocsAPIurl = await ApiEndpoints.BatchDocumentsApiUrl();
        const batchDocsApiData = await GetDataWithParamsFromAPI(batchDocsAPIurl, params, {}, 40);
        if (batchDocsApiData.length > 0) {
            return batchDocsApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetBatchDocsFromApiByBatchID", {});
    }

};


const GetCasesFromApiByBatchDocID = async (params) => {
    try {
        const caseByBatchDocAPIurl = await ApiEndpoints.CaseByBatchDocumentApiUrl();
        const caseByBatchDocApiData = await GetDataWithParamsFromAPI(caseByBatchDocAPIurl, params, {}, 50);
        if (caseByBatchDocApiData.length > 0) {
            return caseByBatchDocApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetCasesFromApiByBatchDocID", {});
    }
};


const GetMapCodeWorkflowFromApi = async (params) => {
    try {
        const mapCodeWorkflowAPIurl = await ApiEndpoints.MapCodeWorkflowApiUrl();
        const mapCodeWorkflowApiData = await GetDataWithParamsFromAPI(mapCodeWorkflowAPIurl, params, {}, 70);
        if (mapCodeWorkflowApiData.length > 0) {
            return mapCodeWorkflowApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetMapCodeWorkflowFromApi", {});
    }
};

const GetBatchListFromApi = async (softLockTimerVal) => {
    try {
        const sessionLoginUser = ApiService.getSessionLoginUserValue();
        const masterServerDBSchema = getMasterServerDBSchema();
        
        const batchParams = {
            fkm_UserLoginID: sessionLoginUser.legacyUserID,
            boardedSiteID: sessionLoginUser.siteID,
            masterServerDBSchema,
            batchID: 0,
            softLockTimer: softLockTimerVal
        }

        const batchListAPIurl = await ApiEndpoints.BatchListApiUrl();
        const batchListApiData = await GetDataWithParamsFromAPI(batchListAPIurl, batchParams, {}, 60);
        if (batchListApiData.length > 0) {
            return batchListApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetBatchListFromApi", {});
    }
};


const GetDocGroupsFromApi = async (params) => {
    try {
        const docGroupAPIurl = await ApiEndpoints.DocGroupListApiUrl();
        const docGroupListApiData = await GetDataWithParamsFromAPI(docGroupAPIurl, params, {}, 70);
        if (docGroupListApiData.length > 0) {
            return docGroupListApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetDocGroupsFromApi", {});
    }
};


const GetDocTypesFromApi = async (params) => {
    try {
        const docTypeAPIurl = await ApiEndpoints.DocTypeListApiUrl();
        const docTypeListApiData = await GetDataWithParamsFromAPI(docTypeAPIurl, params, {}, 80);
        if (docTypeListApiData.length > 0) {
            return docTypeListApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetDocTypesFromApi", {});
    }
};

const GetWorkflowDocuments = async (params) => {
    try {
        const workflowDocumentsApiUrl = await ApiEndpoints.WorkflowDocumentsApiUrl();
        const workflowDocumentsData = await GetDataWithParamsFromAPI(workflowDocumentsApiUrl, params, {}, 80);
        if (workflowDocumentsData.length > 0) {
            return workflowDocumentsData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "WorkflowDocumentsApiUrl", {});
    }
};


const GetDocSourceFromApi = async (params) => {
    try {
        const docSourceAPIurl = await ApiEndpoints.DocSourceListApiUrl();
        const docSourceListApiData = await GetDataWithParamsFromAPI(docSourceAPIurl, params, {}, 90);
        if (docSourceListApiData.length > 0) {
            return docSourceListApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetDocSourceFromApi", {});
    }
};


const GetIndexedByUserFromApi = async (params) => {
    try {
        const indexedByAPIurl = await ApiEndpoints.IndexByListApiUrl();
        const indexedByListApiData = await GetDataWithParamsFromAPI(indexedByAPIurl, params, {}, 100);
        if (indexedByListApiData.length > 0) {
            return indexedByListApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetIndexedByUserFromApi", {});
    }
};


const GetSiteSettingDetailFromApi = async (params, apiKey = -99, index = 0) => {
    try {
        const siteSettingAPIurl = await ApiEndpoints.SiteSettingDetailsApiUrl();
        const siteSettingApiData = await GetDataWithParamsFromAPI(siteSettingAPIurl, params, {}, params.settingsDetailID);
        if (siteSettingApiData.length > 0) {
            return { index, paramsApi: params, siteSettingApiData };
        }
        else {
            const siteSettingApiData = [];
            return { index, paramsApi: params, siteSettingApiData };
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetSiteSettingDetailFromApi", {});
    }
};


const GetSettingsDetailValuesFromApi = async (params, apiKey = -99, index = 0) => {
    try {
        // 🔍 ADDED: Get session context like other APIs do
        const sessionLoginUser = ApiService.getSessionLoginUserValue();
        
        // 🔍 ADDED: Enhance params with session data if not already provided
        const enhancedParams = {
            ...params,
            // Add site context if not already in params
            yTracSiteID: params.yTracSiteID || sessionLoginUser?.siteID,
            //orgID: params.orgID || sessionLoginUser?.stateID,
            userID: params.userID || sessionLoginUser?.legacyUserID
        };

        const SettingsDetailValuesApiUrl = await ApiEndpoints.SettingsDetailValuesApiUrl();
        
        //const settingDetailsApiData = await GetDataWithParamsFromAPI(SettingsDetailValuesApiUrl, params, {}, 101);
        const settingDetailsApiData = await GetDataWithParamsFromAPI(SettingsDetailValuesApiUrl, enhancedParams, {}, 101);
       
        if (settingDetailsApiData.length > 0) {
            return { index, paramsApi: params, settingDetailsApiData };
        }
        else {
            const settingDetailsApiData = [];
            return { index, paramsApi: params, settingDetailsApiData };
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetSettingsDetailValuesFromApi", {});
    }
};

const GetIntegrationID = async (params) => {
    try {
        const integrationIDAPIurl = await ApiEndpoints.IntegrationIDApiUrl();
        const integrationIDApiData = await GetDataWithParamsFromAPI(integrationIDAPIurl, params, {}, 7000);
        if (integrationIDApiData.length > 0) {
            return integrationIDApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetIntegrationID", {});
    }
};

const GetIntegrationInfo = async (params) => {
    try {
        const integrationInfoAPIurl = await ApiEndpoints.IntegrationInfoApiUrl();
        const integrationInfoApiData = await GetDataWithParamsFromAPI(integrationInfoAPIurl, params, {}, 7000);
        if (integrationInfoApiData.length > 0) {
            return integrationInfoApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetIntegrationInfo", {});
    }
};

const GetMessageContentFromApi = async (params) => {
    try {
        const messageContentAPIurl = await ApiEndpoints.MessageContentApiUrl();
        const messageContentApiData = await GetDataWithParamsFromAPI(messageContentAPIurl, params, {}, 7100);
        let textContent = null;
        
        if (Array.isArray(messageContentApiData) && messageContentApiData.length > 0) {
            const firstItem = messageContentApiData[0];
            textContent = firstItem?.messageText || firstItem?.text || firstItem?.content || firstItem?.message || firstItem?.body || firstItem;
        }
        else if (messageContentApiData && typeof messageContentApiData === 'object') {
            textContent = messageContentApiData.messageText || messageContentApiData.text || messageContentApiData.content || messageContentApiData.message || messageContentApiData.body || messageContentApiData;
        }
        else if (typeof messageContentApiData === 'string') {
            textContent = messageContentApiData;
        }
        
        
        // Return in the expected format with messageText property
        if (typeof textContent === 'string') {
            return { messageText: textContent };
        } else if (textContent && typeof textContent === 'object' && !textContent.messageText) {
            // If it's an object but doesn't have messageText, add it
            return { ...textContent, messageText: textContent.text || textContent.content || textContent.message || JSON.stringify(textContent) };
        } else {
            // Return as-is if it already has the right structure or is null
            return textContent;
        }
    }
    catch (error) {
        console.error("Error Details:", {
            message: error.message,
            status: error.status,
            response: error.response?.data
        });
        throw LoggerUtility.ProcessErrorData(error, "GetMessageContentFromApi", {});
    }
};

const getMessageContent = async (params) => {
    try {
        const messageContentApiUrl = await ApiEndpoints.MessageContentApiUrl();
        const messageContentApiData = await GetDataWithParamsFromAPI(messageContentApiUrl, params, {}, 7500);
        if (messageContentApiData.length > 0) {
            return messageContentApiData;
        }
        else {
            return [];
        }
    }
    catch(error) {
        throw LoggerUtility.ProcessErrorData(error, "getMessageContent", {});
    }
}

const getHolidayList = async (params) => {
    try {
        const holidayApiUrl = await ApiEndpoints.HolidayListApiUrl();
        const holidaysApiData = await GetDataWithParamsFromAPI(holidayApiUrl, params, {}, 7500);
        if (holidaysApiData.length > 0) {
            return holidaysApiData;
        }
        return [];
    }
    catch(error) {
        throw LoggerUtility.ProcessErrorData(error, "getHolidayList", {});
    }
}

const GetNoteTemplate = async (params) => {
    try {
        const noteTemplateApiUrl = await ApiEndpoints.NoteTemplateApiUrl();
        const noteTemplateApiData = await GetDataWithParamsFromAPI(noteTemplateApiUrl, params, {}, 7500);
        if (noteTemplateApiData.length > 0) {
            return noteTemplateApiData;
        }
        return [];
    }
    catch(error) {
        throw LoggerUtility.ProcessErrorData(error, "getNoteTemplate", {});
    }
}

const getDataMap= async (params) => {
    try {
        const dataMapApiUrl = await ApiEndpoints.DataMapApiUrl();
        const dataMapApiData = await GetDataWithParamsFromAPI(dataMapApiUrl, params, {}, 7600);
        if (dataMapApiData.length > 0) {
            return dataMapApiData;
        }
        else {
            return [];
        }
    }
    catch(error) {
        throw LoggerUtility.ProcessErrorData(error, "getDataMap", {});
    }
}

const getActiveWorkflowActions = async (params) => {
    try {
        const activeWorkflowActionsUrl = await ApiEndpoints.ActiveWorkflowActionsApiUrl();
        const activeWorkflowActions = await GetDataWithParamsFromAPI(activeWorkflowActionsUrl, params, {}, 7700);
        if (activeWorkflowActions.length > 0) {
            return activeWorkflowActions;
        }
        else {
            return [];
        }
    }
    catch (error){
        throw LoggerUtility.ProcessErrorData(error, "getActiveWorkflowActions", {});
    } 
}

const GetActiveWorkflowList = async () => {
    try {
        const activeWorkflowListApiUrl = await ApiEndpoints.GetActiveWorkflowListApiUrl();
        const activeWorkflowListApiData = await GetDataFromAPI(activeWorkflowListApiUrl, {}, 7701);

        return Array.isArray(activeWorkflowListApiData) ? activeWorkflowListApiData : [];
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActiveWorkflowList", {});
    }
}

const GetActiveQueueList = async (params) => {
    try {
        const activeQueueListApiUrl = await ApiEndpoints.GetActiveQueueListApiUrl();
        const activeQueueListApiData = await GetDataWithParamsFromAPI(activeQueueListApiUrl, params, {}, 7702);

        return Array.isArray(activeQueueListApiData) ? activeQueueListApiData : [];
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActiveQueueList", {});
    }
}

const GetCompletedSites = async (params) => {
    try {
        const completedSitesApiUrl = await ApiEndpoints.CompletedSitesApiUrl();
        const completedSitesApiData = await GetDataWithParamsFromAPI(completedSitesApiUrl, params, {}, 7703);

        return Array.isArray(completedSitesApiData) ? completedSitesApiData : [];
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetCompletedSites", {});
    }
}

const GetCompletedUsers = async (params) => {
    try {
        const completedUsersApiUrl = await ApiEndpoints.CompletedUsersApiUrl();
        const completedUsersApiData = await GetDataWithParamsFromAPI(completedUsersApiUrl, params, {}, 7704);

        return Array.isArray(completedUsersApiData) ? completedUsersApiData : [];
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetCompletedUsers", {});
    }
}

const GetActiveCaseWorkflowListWithCase = async (params) => {
    try {
        const activeCaseWorkflowListWithCaseUrl = await ApiEndpoints.ActiveCaseWorkflowListWithCaseUrl();
        const activeCaseWorkflowListWithCase = await GetDataWithParamsFromAPI(activeCaseWorkflowListWithCaseUrl, params, {}, 7705);
        if (activeCaseWorkflowListWithCase.length > 0) {
            return activeCaseWorkflowListWithCase;
        }
        else {
            return [];
        }
    }
    catch (error){
        throw LoggerUtility.ProcessErrorData(error, "GetActiveCaseWorkflowListWithCase", {});
    } 
}

const GetActiveCaseWorkflowListNoCase = async (params) => {
    try {
        const activeCaseWorkflowListNoCaseUrl = await ApiEndpoints.ActiveCaseWorkflowListNoCaseUrl();
        const activeCaseWorkflowListNoCase = await GetDataWithParamsFromAPI(activeCaseWorkflowListNoCaseUrl, params, {}, 7706);
        if (activeCaseWorkflowListNoCase.length > 0) {
            return activeCaseWorkflowListNoCase;
        }
        else {
            return [];
        }
    }
    catch (error){
        throw LoggerUtility.ProcessErrorData(error, "GetActiveCaseWorkflowListNoCase", {});
    } 
}

const GetUserInfoByEmailFromApi = async (emailAddress) => {
    try {
        const params = {
            email: emailAddress
        }
        const userInfoAPIurl = await ApiEndpoints.UserByEmailApiUrl();
        const userInfoApiData = await GetDataWithParamsFromAPI(userInfoAPIurl, params, {}, 110);
        if (userInfoApiData.length > 0) {
            return userInfoApiData[0];
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetUserInfoByEmailFromApi", {});
    }
};


const GetUserLoginFromApi = async (params) => {
    try {
        // const params = {
        //     userLogin: obj.userLogin,
        //     userLoginID: userLoginID
        // }
        const userLoginAPIurl = await ApiEndpoints.UserLoginApiUrl();
        const userLoginApiData = await GetDataWithParamsFromAPI(userLoginAPIurl, params, {}, 260);
        if (userLoginApiData.length > 0) {
            return userLoginApiData[0];
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetUserLoginFromApi", {});
    }
};


const GetBatchDocumentByIDFromApi = async (params) => {
    try {
        const batchDocAPIurl = await ApiEndpoints.BatchDocumentByIdApiUrl();
        const batchDocApiData = await GetDataWithParamsFromAPI(batchDocAPIurl, params, {}, 120);
        if (batchDocApiData.length > 0) {
            return batchDocApiData[0];
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetBatchDocumentByIDFromApi", {});
    }
};



const GetNarrativeFromApi = async (params) => {
    try {
        const narrativeAPIurl = await ApiEndpoints.NarrativeGetApiUrl();
        const narrativeApiData = await GetDataWithParamsFromAPI(narrativeAPIurl, params, {}, 130);
        if (narrativeApiData.length > 0) {
            return narrativeApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetNarrativeFromApi", {});
    }
};

const GetNarrativeForKeywordsFromApi = async (params) => {
    try {
        const narrativeAPIurl = await ApiEndpoints.NarrativeForKeywordsGetApiUrl();
        const narrativeApiData = await GetDataWithParamsFromAPI(narrativeAPIurl, params, {}, 140);
        if (narrativeApiData.length > 0) {
            return narrativeApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetNarrativeForKeywordsFromApi", {});
    }
};

const BuildNarrativeFromApi = async (params) => {
    try {
        const buildNarrativeAPIurl = await ApiEndpoints.NarrativeBuilderApiUrl();
        const buildNarrativeApiData = await PostDataToAPI(buildNarrativeAPIurl, params, {}, {}, 130);
        if (buildNarrativeApiData.length > 0) {
            return buildNarrativeApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "BuildNarrativeFromApi", {});
    }
};

const AddCaseNarrativeKSFromApi = async (params) => {
    try {
        const addCaseNarrativeAPIurl = await ApiEndpoints.AddCaseNarrativeKSAPIApiUrl();
        return await PostDataToAPI(addCaseNarrativeAPIurl, params, {}, {}, 130);
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "AddCaseNarrativeKSFromApi", {});
    }
};

const DeleteAlertKSFromApi = async (params) => {
    try {
        const deleteAlertAPIurl = await ApiEndpoints.DeleteAlertKSAPIApiUrl();
        const requestBody = {
            caseWorkflowId: params.caseWorkflowId,
            caseId: params.caseId,
            ...(params.userLoginId != null && { userLoginId: params.userLoginId })
        };
        return await PostDataToAPI(deleteAlertAPIurl, requestBody, {}, {}, 130);
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "DeleteAlertKSFromApi", {});
    }
};


const GetUserLockedBatchFromApi = async (params) => {
    try {
        const lockedBatchAPIurl = await ApiEndpoints.UserLockedBatchApiUrl();
        const lockedBatchApiData = await GetDataWithParamsFromAPI(lockedBatchAPIurl, params, {}, 150);
        if (lockedBatchApiData.length > 0) {
            return lockedBatchApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetUserLockedBatchFromApi", {});
    }
};


const GetBatchLockStatusFromApi = async (params) => {
    try {
        const batchLockAPIurl = await ApiEndpoints.BatchLockStatusApiUrl();
        const batchLockApiData = await GetDataWithParamsFromAPI(batchLockAPIurl, params, {}, 160);
        if (batchLockApiData.length > 0) {
            return batchLockApiData[0];
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetBatchLockStatusFromApi", {});
    }
};

const AnalyzeBatchLockStatus = (lockData, currentUserId) => {
    if (!lockData) {
        return { isLockedByOtherUser: false, lockType: 0, lockMessage: "" };
    }

    // Batch has been completed
        if (lockData.lockType === 4 ) {
        return {
            isLockedByOtherUser: true,
            lockType: 4,
            lockMessage: lockData.lockMessage ?? "This batch has been completed by another user and cannot be modified."
        };
    }

    // Batch has been hard locked by another user
    if (lockData.lockType === 3 && lockData.hardLockUserLoginID !== currentUserId) {
        return {
            isLockedByOtherUser: true,
            lockType: 3,
            lockMessage: lockData.lockMessage ?? "This batch is hard locked by another user and cannot be modified."
        };
    }

    // Batch is currently soft locked by another user
    if (lockData.lockType === 2 && lockData.lockUserLoginID !== currentUserId) {
        return {
            isLockedByOtherUser: true,
            lockType: 2,
            lockMessage: lockData.lockMessage ?? "This batch is currently being worked on by another user. Please select a different batch."
        };
    }

    return { isLockedByOtherUser: false, lockType: lockData.lockType || 0, lockMessage: "" };
};

const GetBatchDocumentLockStatusFromApi = async (params) => {
    try {
        const batchDocumentLockAPIurl = await ApiEndpoints.BatchDocumentLockStatusSelectUrl();
        const requestParams = {
            ...params,
            _: Date.now()
        };
        const batchDocumentLockApiData = await GetDataWithParamsFromAPI(batchDocumentLockAPIurl, requestParams, { "Cache-Control": "no-cache", Pragma: "no-cache" }, 161);
        if (batchDocumentLockApiData.length > 0) {
            return batchDocumentLockApiData[0];
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetBatchDocumentLockStatusFromApi", {});
    }
};

const AnalyzeBatchDocumentLockStatus = (lockData, currentUserId) => {
    if (!lockData) {
        return { isLockedByOtherUser: false, lockType: 0, lockMessage: "" };
    }

    // 2 = actively locked. Allow if current user owns the lock.
    if (lockData.lockType === 2 && lockData.lockUserLoginID !== currentUserId) {
        return {
            isLockedByOtherUser: true,
            lockType: 2,
            lockMessage: lockData.lockMessage ?? "This document is currently being worked on by another user."
        };
    }

    // 1 = available (or stale lock) and can proceed.
    return { isLockedByOtherUser: false, lockType: lockData.lockType || 0, lockMessage: "" };
};

const PostBatchDocumentLockStatusToApi = async (batchDocumentLockStatusData) => {
    try {
        const batchDocumentLockAPIurl = await ApiEndpoints.UpdateBatchDocumentLockStatusUrl();
        const batchDocumentLockApiData = await PostDataFromParamsToAPI(batchDocumentLockAPIurl, batchDocumentLockStatusData, {}, 21);
        if (batchDocumentLockApiData.length > 0) {
            return batchDocumentLockApiData[0];
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostBatchDocumentLockStatusToApi", {});
    }
}

const PostBatchLockStatusToApi = async (batchLockStatusData) => {
    try {
        const batchLockAPIurl = await ApiEndpoints.UpdateBatchLockStatusApiUrl();
        const batchLockApiData = await PostDataFromParamsToAPI(batchLockAPIurl, batchLockStatusData, {}, 20);
        if (batchLockApiData.length > 0) {
            return batchLockApiData[0];
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostBatchLockStatusToApi", {});
    }
}

const ExportDocument = async (postData) => {
    try {
        const apiEndPoint = await ApiEndpoints.JScapeExportDocumentApiUrl();
        const apiHeaders = ApiService.getApiHeaders({}, apiEndPoint.ApiKey);
        const configOptions = {};
        const config = { headers: { ...apiHeaders }, configOptions};
        const response = await axios.post(
            apiEndPoint.ApiUrl,
            postData,
            config
        );

        // Check if the response is valid and has data
        if (response.status === 200 && response.data) {
            return response.data
        }
        else {
            console.error("Invalid response structure or no data found");
            return {};
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "ExportDocument", {});
    }
}

const ExportDocLog = async (errorLogData) => {
    try {
        const logAPIurl = await ApiEndpoints.ExportDocLogApiUrl();
        const logApiData = await PostDataToAPI(logAPIurl, errorLogData, {}, {}, 30);
        if (logApiData.length > 0) {
            return logApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "ExportDocLog", {});
    }
}

const GetSystemInformationFromAPI = async (params) => {
    try {
        const systemInformationApiUrl = await ApiEndpoints.SystemInformationApiUrl();
        const systemInformationApiData = await GetDataWithParamsFromAPI(systemInformationApiUrl, params, {}, 7000);
        if (systemInformationApiData.length > 0) {
            return systemInformationApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetSystemInformationFromAPI", {});
    }
};




/*
==========================================
WORKFLOW API - BEGIN
=========================================== 
*/

const GetWorkflowTypeList = async (params) => {
    try {
        const workflowTypeAPIurl = await ApiEndpoints.WorkflowTypesApiUrl();
        const workflowTypeApiData = await GetDataWithParamsFromAPI(workflowTypeAPIurl, params, {}, 170);
        if (workflowTypeApiData.length > 0) {
            return workflowTypeApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetWorkflowTypeList", {});
    }
};

const GetActionTypeList = async (params) => {
    try {
        const actionTypeAPIurl = await ApiEndpoints.ActionTypeListApiUrl();
        const actionTypeApiData = await GetDataWithParamsFromAPI(actionTypeAPIurl, params, {}, 180);
        if (actionTypeApiData.length > 0) {
            return actionTypeApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActionTypeList", {});
    }
};

const GetNextActionTypeList = async (params) => {
    try {
        const nextActionTypeAPIurl = await ApiEndpoints.NextActionTypeListApiUrl();
        const nextActionTypeApiData = await GetDataWithParamsFromAPI(nextActionTypeAPIurl, params, {}, 190);
        if (nextActionTypeApiData.length > 0) {
            return nextActionTypeApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetNextActionTypeList", {});
    }
};

const GetNextActionTypeListReferAction = async (params) => {
    try {
        const nextActionTypeAPIurl = await ApiEndpoints.NextActionTypeListReferActionApiUrl();
        const nextActionTypeApiData = await GetDataWithParamsFromAPI(nextActionTypeAPIurl, params, {}, 190);
        if (nextActionTypeApiData.length > 0) {
            return nextActionTypeApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetNextActionTypeListReferAction", {});
    }
};

const GetIccTypeList = async (params) => {
    try {
        const iccTypeAPIurl = await ApiEndpoints.IccTypeListApiUrl();
        const iccTypeApiData = await GetDataWithParamsFromAPI(iccTypeAPIurl, params, {}, 191);
        if (iccTypeApiData.length > 0) {
            return iccTypeApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetIccTypeList", {});
    }
};

const GetWorkflowNarrative = async (params) => {
    try {
        const workflowNarrativeAPIurl = await ApiEndpoints.WorkflowGetNarrativeApiUrl();
        const workflowNarrativeApiData = await GetDataWithParamsFromAPI(workflowNarrativeAPIurl, params, {}, 192);
        if (workflowNarrativeApiData.length > 0) {
            return workflowNarrativeApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetWorkflowNarrative", {});
    }
};

const PostNewWorkflowSaveToApi = async (newWorkflowSaveData, isWalkIn = false) => {
    try {
        let  newWorkflowAPIurl = await ApiEndpoints.WorkflowSaveApiUrl();
        if (isWalkIn) {
            newWorkflowAPIurl = await ApiEndpoints.WalkInSaveApiUrl();
        }
        const newWorkflowApiData = await PostDataToAPI(newWorkflowAPIurl, newWorkflowSaveData, {}, {}, 193);
        if (newWorkflowApiData.length > 0) {
            return newWorkflowApiData[0];
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostNewWorkflowSaveToApi", {});
    }
}

const PostExistingWorkflowSaveToApi = async (nextWorkflowSaveData) => {
    try {
        const nextWorkflowAPIurl = await ApiEndpoints.WorkflowSaveExistingApiUrl();
        const nextWorkflowApiData = await PostDataToAPI(nextWorkflowAPIurl, nextWorkflowSaveData, {}, {}, 194);
        if (nextWorkflowApiData.length > 0) {
            return nextWorkflowApiData;
        }
        else {
            return null;
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PostExistingWorkflowSaveToApi", {});
    }
}

const GetWorkflowActivityList = async (params) => {
    try {
        const workflowActivityAPIurl = await ApiEndpoints.WorkflowActivityListApiUrl();
        const workflowActivityApiData = await GetDataWithParamsFromAPI(workflowActivityAPIurl, params, {}, 200);
        if (workflowActivityApiData.length > 0) {
            return workflowActivityApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetWorkflowActivityList", {});
    }
};

const GetNoCaseWorkflowActivityList = async (params) => {
    try {
        const noCaseworkflowActivityAPIurl = await ApiEndpoints.NoCaseWorkflowActivityListApiUrl();
        const workflowActivityApiData = await GetDataWithParamsFromAPI(noCaseworkflowActivityAPIurl, params, {}, 200);
        if (workflowActivityApiData.length > 0) {
            return workflowActivityApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetNoCaseWorkflowActivityList", {});
    }
};

const GetCustServiceContactsList = async (params) => {
    try {
        const csContactsAPIurl = await ApiEndpoints.CustServiceContactListApiUrl();
        const csContactsApiData = await GetDataWithParamsFromAPI(csContactsAPIurl, params, {}, 220);
        if (csContactsApiData.length > 0) {
            return csContactsApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetCustServiceContactsList", {});
    }
};

const GetActiveWorkflowFinancialWorkList = async (params) => {
    try {
        const awFinancialAPIurl = await ApiEndpoints.ActiveWorkflowFinancialWorkListApiUrl();
        const awFinancialApiData = await GetDataWithParamsFromAPI(awFinancialAPIurl, params, {}, 240);
        if (awFinancialApiData.length > 0) {
            return awFinancialApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActiveWorkflowFinancialWorkList", {});
    }
};

const GetActiveWorkflowNoCaseFinancialWorkList = async (params) => {
    try {
        const awFinancialAPIurl = await ApiEndpoints.ActiveWorkflowNoCaseFinancialWorkListApiUrl();
        const awFinancialApiData = await GetDataWithParamsFromAPI(awFinancialAPIurl, params, {}, 260);
        if (awFinancialApiData.length > 0) {
            return awFinancialApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActiveWorkflowFinancialWorkList", {});
    }
};

const LockUnlockCaseWorkflowByCaseWorkflowID = async (params) => {
    try {
        const lockUnlockUrl = await ApiEndpoints.LockUnlockCaseWorkflowByCaseWorkflowIDApiUrl();
        const lockUnlockData = await PostDataFromParamsToAPI(lockUnlockUrl, params, {}, 300);
        if (lockUnlockData.length > 0) {
            return lockUnlockData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "LockUnlockCaseWorkflowByCaseWorkflowID", {});
    }
};

const UnlockCaseWorkflowsByUserLoginID = async (params) => {
    try {
        const lockUnlockUrl = await ApiEndpoints.UnlockCaseWorkflowsByUseLoginIDApiUrl();
        const lockUnlockData = await PostDataFromParamsToAPI(lockUnlockUrl, params, {}, 310);
        if (lockUnlockData.length > 0) {
            return lockUnlockData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "UnlockCaseWorkflowsByUserLoginID", {});
    }
};

const postTakeAction = async (postData) => {
    const TakeActionApiUrl = await ApiEndpoints.TakeActionApiUrl()
    const response = await PostDataToAPI(TakeActionApiUrl, postData, {}, {}, 7700);
    return response
}

const PreviewTakeActionAddToList = async (params) => {
    try {
        const addToListUrl = await ApiEndpoints.AddToListApiUrl();
        const addToListData = await PostDataToAPI(addToListUrl, params, {}, {}, 320);
        if (addToListData.length > 0) {
            return addToListData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "PreviewTakeActionAddToList", {});
    }
};

const GetEventsGridDataNoCaseApiUrl = async (params) => {
    try {
        const eventsGridDataNoCaseAPIurl = await ApiEndpoints.EventsGridDataNoCaseApiUrl();
        const eventsGridDataNoCaseApiData = await GetDataWithParamsFromAPI(eventsGridDataNoCaseAPIurl, params, {}, 270);
        if (eventsGridDataNoCaseApiData.length > 0) {
            return eventsGridDataNoCaseApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetEventsGridDataNoCaseApiUrl", {});
    }
};

const GetActionTakenDetails = async (params) => {
    try {
        const actionTakenApiUrl = await ApiEndpoints.ActionDetailsApiUrl();
        const actionTakenApiData = await GetDataWithParamsFromAPI(actionTakenApiUrl, params, {}, 280)
        if (actionTakenApiData.length > 0) {
            return actionTakenApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
    }
}


// Function for getting dropdown types
const GetAllDropdownTypes = async (params) => {
    try {
        const dropDownTypesAPIurl = await ApiEndpoints.WorkflowStatusOptionsApiUrl();
        const dropDownTypesApiData = await GetDataWithParamsFromAPI(dropDownTypesAPIurl, params, {}, 250);
        if (dropDownTypesApiData.length > 0) {
            return dropDownTypesApiData;
        }
        return [];
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetAllDropdownTypes", {});
    }
};

// new function for Get Next Task
const WorkflowGetNextTask = async (params) => {
    try {
        const nextWorkTaskAPIurl = await ApiEndpoints.GetNextTaskApiUrl();
        const nextWorkTaskApiData = await GetDataWithParamsFromAPI(nextWorkTaskAPIurl, params, {}, 250);
        if (nextWorkTaskApiData && nextWorkTaskApiData.length > 0) {
            return nextWorkTaskApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetWfStatusOptionList", {});
    }
};

const GetActiveWorkflowInitialInfoList = async (params) => {
    try {
        const awInitialInfoAPIurl = await ApiEndpoints.ActiveWorkflowInitialInfoListApiUrl();
        const awInitialInfoApiData = await GetDataWithParamsFromAPI(awInitialInfoAPIurl, params, {}, 240);
        if (awInitialInfoApiData.length > 0) {
            return awInitialInfoApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActiveWorkflowInitialInfoList", {});
    }
};

const GetActiveWorkflowSelectList = async () => {
    try {
        const awSelectAPIurl = await ApiEndpoints.ActiveWorkflowSelectListApiUrl();
        const awSelectApiData = await GetDataWithoutParamsFromAPI(awSelectAPIurl, {},100);
         return Array.isArray(awSelectApiData) ? awSelectApiData : [];
        // if (awSelectApiData.length > 0) {
        //     return awSelectApiData;
        // }
        // else {
        //     return [];
        // }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActiveWorkflowSelectList", {});
    }
};

// const GetActiveQueueList = async (params) => {
//     try {
//         const awQueueAPIurl = await ApiEndpoints.ActiveQueueListApiUrl();
//         const awQueueApiData = await GetDataWithParamsFromAPI(awQueueAPIurl, params, {}, 240);
//         return Array.isArray(awQueueApiData) ? awQueueApiData : [];
//         // if (awQueueApiData.length > 0) {
//         //     return awQueueApiData;
//         // }
//         // else {
//         //     return [];
//         // }
//     }
//     catch (error) {
//         throw LoggerUtility.ProcessErrorData(error, "GetActiveQueueList", {});
//     }
// };

const GetActiveWorkflowWorkList = async (params) => {
    try {
        const awWorkListAPIurl = await ApiEndpoints.ActiveWorkflowWorkListApiUrl();
        const awWorkListApiData = await GetDataWithParamsFromAPI(awWorkListAPIurl, params, {},100);
        return Array.isArray(awWorkListApiData) ? awWorkListApiData : [];
        // if (awWorkListApiData.length > 0) {
        //     return awWorkListApiData;
        // }
        // else {
        //     return [];
        // }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActiveWorkflowWorkList", {});
    }
};

const StartQAWorkflow = async (params) => {
    try {
        const startQAApiUrl = await ApiEndpoints.StartQAWorkflowsApiUrl();
        const apiHeaders = ApiService.getApiHeaders({}, startQAApiUrl.ApiKey);
        const config = { headers: { ...apiHeaders } };
        const response = await axios.post(startQAApiUrl.ApiUrl, params, config);
        if (response.status === 200 && response.data) {
            return response.data;
        }
        return null;
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "StartQAWorkflow", {});
    }
};

const StartQAWorkflows = async (items) => {
    const results = [];
    for (const item of items) {
        const result = await StartQAWorkflow(item);
        results.push(result);
    }
    return results;
};

const SearchCompletedActions = async (params) => {
    try {
        const completedActionsApiUrl = await ApiEndpoints.CompletedActionsSearchApiUrl();
        const apiHeaders = ApiService.getApiHeaders({}, completedActionsApiUrl.ApiKey);
        const config = { headers: { ...apiHeaders } };
        const response = await axios.post(
            completedActionsApiUrl.ApiUrl,
            params,
            config
        );

        if (response.status === 200 && response.data) {
            return response.data;
        }

        return {
            items: [],
            totalCount: 0,
            pageNumber: 1,
            pageSize: 0,
            totalPages: 0
        };
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "SearchCompletedActions", {});
    }
};

const GetNextTabEnableWorkflowsList = async (params) => {
    try {
        const nextTabEnableWorkflowsAPIurl = await ApiEndpoints.NextTabEnableWorkflowsApiUrl();
        const nextTabEnableWorkflowsApiData = await GetDataWithParamsFromAPI(nextTabEnableWorkflowsAPIurl, params, {}, 300);
        if (nextTabEnableWorkflowsApiData.length > 0) {
            return nextTabEnableWorkflowsApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetNextTabEnableWorkflowsList", {});
    }
};

const GetAutoEndWorkflowsList = async (params) => {
    try {
        const autoEndWorkflowsListAPIurl = await ApiEndpoints.AutoEndWorkflowsListApiUrl();
        const autoEndWorkflowsListApiData = await GetDataWithParamsFromAPI(autoEndWorkflowsListAPIurl, params, {}, 240);
        //return Array.isArray(autoEndWorkflowsListApiData) ? autoEndWorkflowsListApiData : [];
        if (autoEndWorkflowsListApiData.length > 0) {
            return autoEndWorkflowsListApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetAutoEndWorkflowsList", {});
    }
};

const GetActionOptionsList = async (params) => {
    try {
        const actionOptionsAPIurl = await ApiEndpoints.ActionOptionsListApiUrl();
        const actionOptionsApiData = await GetDataWithParamsFromAPI(actionOptionsAPIurl, params, {}, 190);
        if (actionOptionsApiData.length > 0) {
            return actionOptionsApiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActionOptionsList", {});
    }
};


const GetChannelRoleCategoryOptions = async (params) => {
    try {
        const apiUrl = await ApiEndpoints.ChannelRoleCategoryOptionsApiUrl();
        const apiData = await GetDataWithParamsFromAPI(apiUrl, params, {}, 190);
        if (apiData.length > 0) {
            return apiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetChannelRoleCategoryOptions", {});
    }
};

const GetResultListTypeData = async (params) => {
    try {
        const apiUrl = await ApiEndpoints.ResultListTypeDataApiUrl();
        const apiData = await GetDataWithParamsFromAPI(apiUrl, params, {}, 190);
        if (apiData.length > 0) {
            return apiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetResultListTypeData", {});
    }
};


const GetResultListMapData = async (params) => {
    try {
        const apiUrl = await ApiEndpoints.ResultListMapDataApiUrl();
        const apiData = await GetDataWithParamsFromAPI(apiUrl, params, {}, 190);
        if (apiData.length > 0) {
            return apiData;
        }
        else {
            return [];
        }
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetResultListMapData", {});
    }
};


const GetActiveWorkflowWalkInList = async (params) => {
    try {
        const awWalkInListAPIurl = await ApiEndpoints.ActiveWorkflowWalkInListApiUrl();
        const awWalkInListApiData = await GetDataWithParamsFromAPI(awWalkInListAPIurl, params, {},100);
        return Array.isArray(awWalkInListApiData) ? awWalkInListApiData : [];
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActiveWorkflowWalkInList", {});
    }
};


const GetActiveWorkflowLegalList = async (params) => {
    try {
        const awLegalListAPIurl = await ApiEndpoints.ActiveWorkflowLegalListApiUrl();
        const awLegalListApiData = await GetDataWithParamsFromAPI(awLegalListAPIurl, params, {},100);
        return Array.isArray(awLegalListApiData) ? awLegalListApiData : [];
    }
    catch (error) {
        throw LoggerUtility.ProcessErrorData(error, "GetActiveWorkflowLegalList", {});
    }
};

/*
==========================================
WORKFLOW API - END
===========================================
*/


const ApiManager = {

    GetApiHeaders,

    GetDataFromAPI,
    PostDataToAPI,
    GetDataWithParamsFromAPI,

    FetchAppBarPermissions,
    FetchControlsPermissions,

    PostNewDocToApi,
    PostDocTransferLogG4ToApi,
    PostManageKeywordToApi,
    PostBatchInsertUpdateToApi,
    PostBatchDocumentToApi,
    PostBatchLockStatusToApi,
    PostBatchDocumentLockStatusToApi,
    PostLogFromWebToApi,

    GetUncFilePathFromApi,
    GetMetadataFromApi,
    SaveFileToPhysicalPath,
    DeleteDocumentFromApi,

    GetUserLockedBatchFromApi,
    GetUserInfoByEmailFromApi,
    GetUserLoginFromApi,
    GetBatchLockStatusFromApi,
    AnalyzeBatchLockStatus,
    GetBatchDocumentLockStatusFromApi,
    AnalyzeBatchDocumentLockStatus,

    GetOrganizationFromApiByUserID,
    GetChildOrganizationFromApiByUserID,

    GetCaseDataFromApiByID,
    GetCaseDataFromDbByID,
    CheckMainframeConnectivity,
    GetDocSearchFromApiByID,
    GetCaseDocsFromApiByCaseID,
    GetCaseDocsFromApiByCaseWorkflowID,
    GetBatchDocsFromApiByBatchID,
    GetBatchDocumentByIDFromApi,
    GetCasesFromApiByBatchDocID,
    PostCaseDataFromScrapeToApi,
    GetNarrativeFromApi,
    GetNarrativeForKeywordsFromApi,
    BuildNarrativeFromApi,
    AddCaseNarrativeKSFromApi,
    DeleteAlertKSFromApi,
    GetBatchListFromApi,
    GetDocGroupsFromApi,
    GetMapCodeWorkflowFromApi,
    GetDocTypesFromApi,
    GetWorkflowDocuments,
    GetDocSourceFromApi,
    GetIndexedByUserFromApi,

    GetSiteSettingDetailFromApi,
    GetSettingsDetailValuesFromApi,
    GetIntegrationID,
    GetIntegrationInfo,
    GetMessageContentFromApi,
    getMessageContent,
    getHolidayList,
    getDataMap,
    getActiveWorkflowActions,
    GetActiveWorkflowList,
    GetActiveQueueList,
    GetCompletedSites,
    GetCompletedUsers,

    GetWorkflowTypeList,
    GetActionTypeList,
    GetNextActionTypeList,
    GetNextActionTypeListReferAction,
    GetIccTypeList,
    GetWorkflowNarrative,
    PostNewWorkflowSaveToApi,
    ExportDocument,
    ExportDocLog,

    GetWorkflowActivityList,
    GetNoCaseWorkflowActivityList,
    GetCustServiceContactsList,
    GetActiveWorkflowFinancialWorkList,
    GetActiveWorkflowNoCaseFinancialWorkList,
    GetAllDropdownTypes,
    GetEventsGridDataNoCaseApiUrl,
    WorkflowGetNextTask,
    SearchCompletedActions,
    StartQAWorkflows,

    LockUnlockCaseWorkflowByCaseWorkflowID,
    UnlockCaseWorkflowsByUserLoginID,
    PreviewTakeActionAddToList,
    PostExistingWorkflowSaveToApi,

    GetNextTabEnableWorkflowsList,
    GetSystemInformationFromAPI,
    GetActiveWorkflowInitialInfoList,
    GetActiveWorkflowSelectList,
    // GetActiveQueueList,
    GetActiveWorkflowWorkList,
    GetAutoEndWorkflowsList,
    GetNoteTemplate,
    GetActionOptionsList,
    GetNoteTemplate,
    GetChannelRoleCategoryOptions,
    GetResultListTypeData,
    GetResultListMapData,
    postTakeAction,
    GetResultListMapData,
    GetActiveCaseWorkflowListWithCase,
    GetActiveCaseWorkflowListNoCase,
    GetActiveWorkflowWalkInList,
    GetActiveWorkflowLegalList,
    GetActionTakenDetails
};


export default ApiManager;
